var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgE6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.8 25.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-E6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46,7.65c-2,.27-4.05.59-6.09.88-.71.1-1.61.09-2.07.71a1.47,1.47,0,0,0,.19,2L4.37,15l1.41,1.38c.09.1.09.11.07.25L5.45,19l-.31,1.85L4.58,24.1A1.41,1.41,0,0,0,5,25.22l1,.41c.45.09,1.21-.43,1.54-.6L13.4,22l6.33,3.31,1.11.37a1.41,1.41,0,0,0,1.39-1.53L21,16.47c.12-.21,5.5-5.22,5.67-5.62a1.58,1.58,0,0,0,0-1.39,1.52,1.52,0,0,0-1.28-.8l-7.11-1c-.28,0-.23-.11-.44-.52L14.5.48A1.49,1.49,0,0,0,12.37.41C12.16.62,10.91,3.16,10,5.12c-.32.66-.61,1.26-.82,1.68-.11.25-.21.43-.26.54-.14.28,0,.25-.41.3Z",
    transform: "translate(0 0)",
    fill: "#e3e8ee",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE6);
export default __webpack_public_path__ + "static/media/E6.58bd0e9a260ad548be209de3988e2727.svg";
export { ForwardRef as ReactComponent };